import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { kycChooseChips } from '../actions';

// Text area input field for KYC
class KycTextArea extends Component {
    constructor(props) {
        super(props);
        this.inputField = React.createRef();
        let { inputObj } = this.props;
        if (!inputObj.meta.options || inputObj.meta.options.length === 0) {
            inputObj.meta.options = [
                {
                    parentQuestionId: inputObj.id,
                    text: '',
                },
            ];
        }
        this.state = {
            inputObj: inputObj
        };
    }

    handleChange(event) {
        let textVal = event.target.value;
        this.setState((state) => {
            state.inputObj.meta.options[0].text = textVal;
            // Clear previous answers
            state.inputObj.answer = [];
            return state;
        });
    }

    componentDidMount() {
        let { inputObj } = this.props;
        // Fetch saved answer if available
        if (inputObj.answer.length > 0) {
            this.setState((state) => {
                state.inputObj.meta.options[0].text = inputObj.answer[inputObj.answer.length - 1].text;
                return state;
            });
        }

        const keyDown = fromEvent(this.inputField.current, 'keydown');
        const debounce = keyDown.pipe(debounceTime(1000));
        this.subscriber = debounce.subscribe((val) => {
            let option = {
                parentQuestionId: inputObj.id,
                text: this.inputField.current.value,
            };
            this.props.kycChooseChips(inputObj, option);
        });
    }

    componentWillUnmount() {
        if (this.subscriber) {
            this.subscriber.unsubscribe();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.isValid !== nextProps.inputObj.isValid) {
            this.setState((state) => {
                state.isValid = nextProps.inputObj.isValid;
                return state;
            });
        }
    }

    validateField(event) {
        let { inputObj } = this.state;
        if (inputObj.meta.model.validation.mandatory && !event.target.value) {
            this.setState((state) => {
                state.isValid = false;
                return state;
            });
        } else if (inputObj.meta.model.validation.mandatory && event.target.value) {
            this.setState((state) => {
                state.isValid = true;
                return state;
            });
        }
    }

    render() {
        let { inputObj, isValid } = this.state;
        let { kyc } = this.props;
        let inputClasses = () => {
            let className = 'input';
            if (typeof isValid !== 'undefined' && !isValid) {
                className += ' input--error';
            }
            if (kyc.completed) {
                className += ' input--disabled';
            }
            return className;
        };
        return (
            <div className="kyc__radio">
                <div className="form">
                    <p className="kyc__label">{inputObj.question}</p>
                    <div className={inputClasses()}>
                        <label className="input__label">
                            <textarea
                                disabled={kyc.completed}
                                ref={this.inputField}
                                value={inputObj.meta.options[0].text}
                                onBlur={this.validateField.bind(this)}
                                onChange={this.handleChange.bind(this)}
                                type={inputObj.meta.model.type.toLowerCase()}
                                placeholder="Svar"
                                className="input__text-area"
                            />
                            {typeof this.state.isValid !== 'undefined' && !this.state.isValid ? (
                                <div className="input__required-information">Fältet är obligatoriskt</div>
                            ) : null}
                        </label>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        kyc: state.kyc,
    };
};

KycTextArea = connect(mapStateToProps, {
    kycChooseChips,
})(KycTextArea);

export default KycTextArea;
